module.exports = __webpack_public_path__ + "img/16_40.14ec2a13.png";